import { ga } from 'js/analytics/adapters'

export function trackInstallClick(device) {
  ga.track('Install', {
    hitType: 'event',
    eventCategory: 'App store buttons',
    eventLabel: device === 'iOS' ? 'App store' : 'Google play',
    eventValue: 3,
  })
}
